import React from "react";
import onDateEdit from "../util/forms/onDateEdit";
import { InputAdornment, TextField } from "@mui/material";
import { DesktopDatePicker, MobileDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

export const DatePicker = ({
  value,
  reactComponent,
  name,
  helperText,
  autoFocus = false,
}) => (
  <>
    <DesktopDatePicker
      disablePast
      className="desktop-date-picker"
      value={value}
      onChange={(dayjsDate) => {
        onDateEdit(dayjsDate, name, reactComponent);
      }}
      components={{
        OpenPickerIcon: () => (
          <img className="date-picker-icon" src="/img/svg_icons/Calendar.svg" />
        ),
      }}
      renderInput={(params) => (
        <TextField
          onFocus={(e) => {
            onDateEdit(e.target.value, name, reactComponent);
          }}
          autoFocus={autoFocus}
          sx={{
            "& .MuiInputBase-root": {
              borderRadius: 3,
              border: "1px solid white",
              maxWidth: 300,
              maxHeight: 55,
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "& .MuiInputBase-input": {
              caretColor: "white",
              paddingTop: "8px",
              paddingBottom: 1,
              color: "white",
              fontSize: 32,
            },
            "& .MuiInputBase-input::placeholder": {
              color: "white",
              opacity: 0.95,
              fontSize: 32,
              fontFamily: '"proxima-nova", "sans-serif"',
              position: "relative",
              top: 0,
            },
            "& .MuiFormHelperText-root.Mui-error": {
              color: "orange",
              fontWeight: "bold",
              maxWidth: 300,
              textAlign: "center",
              marginLeft: 0,
              marginRight: 0,
            },
          }}
          helperText={helperText}
          variant="outlined"
          {...params}
          error={!!helperText}
          inputProps={{
            ...params.inputProps,
            placeholder: "mm / dd / yyyy",
          }}
        />
      )}
      name="date"
      PopperProps={{
        placement: "bottom",
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [32, 0],
            },
          },
        ],
        sx: {
          "& .MuiPaper-root": {
            borderRadius: "15px",
          },
        },
      }}
    />
    <MobileDatePicker
      value={value}
      className="mobile-date-picker"
      disablePast
      disableMaskedInput={false}
      onChange={(dayjsDate) => {
        onDateEdit(dayjsDate, name, reactComponent);
      }}
      components={{
        OpenPickerIcon: () => (
          <img className="date-picker-icon" src="/img/svg_icons/Calendar.svg" />
        ),
      }}
      renderInput={(params) => (
        <TextField
          onFocus={(e) => {
            onDateEdit(e.target.value, name, reactComponent);
          }}
          autoFocus={autoFocus}
          sx={{
            "& .MuiInputBase-root": {
              borderRadius: 3,
              border: "1px solid white",
              maxWidth: 300,
              maxHeight: 55,
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "& .MuiInputBase-input": {
              caretColor: "white",
              paddingTop: "8px",
              paddingBottom: 1,
              color: "white",
              fontSize: 32,
              textAlign: "center",
            },
            "& .MuiInputBase-input::placeholder": {
              color: "white",
              opacity: 0.95,
              fontSize: 32,
              fontFamily: '"proxima-nova", "sans-serif"',
              position: "relative",
              top: 0,
            },
            "& .MuiFormHelperText-root.Mui-error": {
              color: "orange",
              fontWeight: "bold",
              maxWidth: 300,
              textAlign: "center",
              marginLeft: 0,
              marginRight: 0,
            },
          }}
          variant="outlined"
          {...params}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment
                className="date-picker-icon-mobile-wrapper"
                position="start"
              >
                <img
                  className="date-picker-icon"
                  src="/img/svg_icons/Calendar.svg"
                />
              </InputAdornment>
            ),
          }}
          inputProps={{
            ...params.inputProps,
            placeholder: "mm / dd / yyyy",
          }}
          helperText={helperText}
          error={!!helperText}
        />
      )}
      name="date"
    />
  </>
);
